import type { CSSProperties } from 'react';
import { ICONS, type IconName } from '../icons';

// Inline SVG icon from the bundled Material Symbols Outlined (400) subset. Decorative by default;
// pass `label` to expose it to assistive tech.
export function Icon(props: { name: IconName; size?: number; className?: string; label?: string }) {
  const style: CSSProperties | undefined = props.size ? { width: props.size, height: props.size } : undefined;
  return (
    <span
      className={`icon ${props.className ?? ''}`}
      style={style}
      role={props.label ? 'img' : undefined}
      aria-label={props.label}
      aria-hidden={props.label ? undefined : true}
      data-icon={props.name}
      dangerouslySetInnerHTML={{ __html: ICONS[props.name] }}
    />
  );
}
